var _excluded = ["img", "size"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import avatar from '../../../assets/images/google_profile.jpg';
import './avatar.scss';
var Avatar = function Avatar(_ref) {
  var img = _ref.img,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "avatar avatar-".concat(size, " align-middle me-2")
  }, rest), /*#__PURE__*/React.createElement("img", {
    src: img,
    alt: "user avatar",
    className: "avatar-img rounded-circle"
  }));
};
Avatar.defaultProps = {
  size: 'xs',
  img: avatar
};
export default Avatar;